module.exports = __webpack_public_path__ + "static/img/配置管理@2x.30cfdfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/配置管理@2x.png
// module id = 6mhu
// module chunks = 1